import React, { useEffect, useState } from 'react';
import {
  onBoardingBillingPlanByCountryCodeApi,
  onBoardingSavePlanApi,
} from '../../constants/ApiConfigs';
import { callApiWithoutDispatch } from '../../utils/apiUtils';
import PlanContainer from '../../features/signup/components/PlanContainer/PlanContainer';
import { FLEET_BILLING_MODE } from '../billingUsage/utils/constants';
import { PropTypes } from '../../components/notificationAlert/container';
import { I18n } from 'react-redux-i18n';
import { Button } from 'react-bootstrap';
const SubscriptionCancelled = ({ auth, loadingActions, topOffset = 0 }, context) => {
  const [billingPlanByCountryCode, setBillingPlanByCountryCode] =
    useState(null);

  useEffect(() => {
    handleLoadInitialData();
  }, [auth]);

  const handleLoadInitialData = async () => {
    if (!billingPlanByCountryCode) {
      loadingActions?.showLoadingSpiner();
      try {
        const response = await callApiWithoutDispatch(
          onBoardingBillingPlanByCountryCodeApi,
          {
            method: 'GET',
            params: {
              countryCode: auth?.selectedFleet?.countryCode,
              fleetId: auth?.selectedFleet?.fleetId,
            },
          }
        );
        if (response?.res?.data) {
          setBillingPlanByCountryCode(response?.res?.data);
        } else {
          context.notification(
            'error',
            'Failed to get billing plan by country code'
          );
        }
      } catch (error) {
        context.notification(
          'error',
          'Failed to get billing plan by country code'
        );
      } finally {
        loadingActions?.hideLoadingSpiner();
      }
    }
  };

  const customPlanBasedCurrentBillingPlan = () => {
    if (!billingPlanByCountryCode || billingPlanByCountryCode.length === 0) {
      return [];
    }
    return billingPlanByCountryCode?.map((plan, index) => {
      if (plan.billingMode === FLEET_BILLING_MODE.invoice) {
        plan.buttonText = 'Let’s Talk!';
      } else {
        plan.buttonText = 'signup.selectPlan'
      }
      return plan;
    });
  };
  const handleSubmit = async (planId, billingType) => {
    try {
      loadingActions.showLoadingSpiner();
      const response = await callApiWithoutDispatch(onBoardingSavePlanApi, {
        method: 'POST',
        body: JSON.stringify({
          fleetId: auth?.selectedFleet?.fleetId,
          userId: auth?.user?._id || '',
          planId: planId,
          billingType: billingType,
          returnUrl: `${window.location.origin}`,
        }),
      });
      const result = response.res;
      if (result?.success) {
        if (result?.billingMode === 'auto') {
          if (result?.resultPayment?.url) {
            window.location.href = result?.resultPayment?.url;
          }
        }
      } else {
        context.notification('error', 'Failed to select plan');
      }
    } catch (error) {
      context.notification('error', 'Failed to select plan');
    } finally {
      loadingActions.hideLoadingSpiner();
    }
  };

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <div
        style={{
          width: '100%',
          backgroundColor: '#04BE76',
          position: 'fixed',
          top: topOffset || 0,
          left: '0',
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 20px',
          zIndex: 1040,
        }}
      >
        <span
          style={{
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {`Subscribe to a plan to continue using the service`}
        </span>
        <Button
          className="btn-update-payment"
          href={'#'}
          target="_blank"
          variant="link"
          style={{
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: 700,
            border: '1px solid #FFFFFF',
            padding: '5px 15px',
            borderRadius: '5px',
          }}
        >
          View Plans
        </Button>
      </div>
      <div className="subscription-cancelled-container choose-plan-popup">
        <div className="fleet-onboarding choosePlanSubscriptionCancelled">
          <PlanContainer
            pricingConfigs={customPlanBasedCurrentBillingPlan()}
            onSubmit={handleSubmit}
            billingPlanFleetSelected={{}}
            title={I18n.t('billingUsage.subscriptionEnded')}
          />
        </div>
      </div>
    </div>
  );
};

SubscriptionCancelled.contextTypes = {
  notification: PropTypes.func,
};

export default SubscriptionCancelled;
